import { render, staticRenderFns } from "./TaxationCreateUpdate.vue?vue&type=template&id=35c59bcb&scoped=true&"
import script from "./TaxationCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TaxationCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TaxationCreateUpdate.vue?vue&type=style&index=0&id=35c59bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c59bcb",
  null
  
)

export default component.exports